import * as types from "../redux/types";
import backend from "../api/api";
import { store } from "../redux/store";
import { message } from "antd";

// let Protected = store.getState().auth.Protected ? true : "";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const getSalesReportGraph = async (
  start,
  end,
  invoice_number,
  delivery_date,
  Payment_method,
  status,
  contact,
  location,
  account
) => {
  try {
    const response = await backend.get(
      `api/order/invoices/?is_public=${
        store.getState().auth.Protected ? true : ""
      }&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}`,
      getConfig()
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getSalesReport =
  (
    start,
    end,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account
  ) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/order/invoices/?is_public=${
          store.getState().auth.Protected ? true : ""
        }&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}`,
        getConfig()
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
    }
  };
export const getSalesReportP =
  (
    start,
    end,
    keyward,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account,
    pageno = 1,
    page_size = 100
  ) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/order/invoicesP/?is_public=${
          store.getState().auth.Protected ? true : ""
        }&keyward=${keyward}&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}&page=${pageno}&page_size=${page_size}`,
        getConfig()
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
    }
  };

export const getEcommerceSales =
  (
    start,
    end,
    keyward,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account,
    pageno = 1,
    page_size = 100
  ) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/order/invoicesP/?is_public=${
          store.getState().auth.Protected ? true : ""
        }&keyward=${keyward}&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}&page=${pageno}&page_size=${page_size}`,
        getConfig()
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
    }
  };
export const getVATReport =
  (
    start,
    end,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account,
    contains_item = "true"
  ) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/order/vat/?is_public=${
          store.getState().auth.Protected ? true : ""
        }&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}&contains_item=${contains_item}`,
        getConfig()
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
    }
  };

export const getSalesReportByOutLetMonth =
  (location, month, year) => async (dispatch) => {
    try {
      const response = await backend.get(
        `api/order/invoices/?is_public=${
          store.getState().auth.Protected ? true : ""
        }&month=${month}&year=${year}&location=${location}`,
        getConfig()
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
    }
  };

export const getSalesReportByInvoiceCount = (from, to) => async (dispatch) => {
  try {
    const response = await backend.get(
      `api/order/report/${from}/${to}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getDeliveryReport =
  (
    start,
    end,
    invoice_number,
    delivery_date,
    Payment_method,
    status,
    contact,
    location,
    account,
    DeliveryType = ""
  ) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/order/delivery/?is_public=${
          store.getState().auth.Protected ? true : ""
        }&start=${start}&end=${end}&invoice_number=${invoice_number}&delivery_date=${delivery_date}&Payment_method=${Payment_method}&status=${status}&contact=${contact}&location=${location}&account=${account}&DeliveryType=${DeliveryType}`,
        getConfig()
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
    }
  };

export const getServiceReport =
  (start, end, keyward, employe__id = "", pageno = 1, page_size = 10) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/order/ServicesP/?is_public=${
          store.getState().auth.Protected ? true : ""
        }&start=${start}&end=${end}&keyward=${keyward}&employe__id=${employe__id}&page=${pageno}&page_size=${page_size}`,
        getConfig()
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
    }
  };


  
export const getStockHistory = (title) => async () => {
  try {
    const response = await backend.get(
      `api/order/stockhistory/?title=${title}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error.response);
  }
};

export const getStockHistoryAll = () => async () => {
  try {
    const response = await backend.get(`api/order/stockhistoryall/`, getConfig());
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error.response);
  }
};

export const getInvoicePaymentsReport =
  (
    start,
    end,
    keyward,
    invoice_id,
    location,
    month,
    year,
    account,
    is_public,
    pageno = 1,
    page_size = 100
  ) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/order/invoicepayments-report/?invoice__is_public=${
          is_public !== undefined ? is_public : ""
        }&keyward=${keyward}&start=${start}&end=${end}&invoice__id=${invoice_id}&invoice__location__id=${location}&month=${month}&year=${year}&account=${account}&page=${pageno}&page_size=${page_size}`,
        getConfig()
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
    }
  };

export const getMonthlySalesReport = async (year, month, location = null) => {
  try {
    let url = `api/order/dailysalesreport/monthly-sales/?year=${year}&month=${month}`;
    
    if (location) {
      url += `&location=${location}`;
    }

    const response = await backend.get(url, getConfig());    
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching monthly sales report:', error);
    const errorMessage = error.response && error.response.data && error.response.data.error 
      ? error.response.data.error 
      : 'Failed to fetch sales report';
    throw new Error(errorMessage);
  }
};

// Get top selling products for each locations
export const getTopProductsByLocation = async (year, month) => {
  try {
    const url = `api/order/top-selling-products/single_location/?year=${year}&month=${month}`;
    const response = await backend.get(url, getConfig());
    
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching top products by location:', error);
    const errorMessage = error.response.data.error 
      ? error.response.data.error 
      : 'Failed to fetch top selling products by location';
    throw new Error(errorMessage);
  }
};

// Get top selling products across all locations
export const getTopProductsAllLocations = async (year, month) => {
  try {
    const url = `api/order/top-selling-products/all-location/?year=${year}&month=${month}`;
    const response = await backend.get(url, getConfig());
    
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching top products for all locations:', error);
    const errorMessage = error.response.data.error 
      ? error.response.data.error 
      : 'Failed to fetch top selling products for all locations';
    throw new Error(errorMessage);
  }
};